/**
 * Comprehensive list of Electronic Health Record (EHR) systems
 * and smart search/relevance sorting utilities.
 */

// Fixed Top 5 most common EHRs displayed initially
import { filterAndSortList } from "../utils/searchUtils";
export const FIXED_TOP_EHRS = [
  "Epic",
  "Cerner",
  "athenahealth",
  "eClinicalWorks",
  "NextGen",
  "MEDITECH",
];

// Master EHR list
export const ALL_EHRS = [
  "ACOM Health",
  "AdvancedMD",
  "Allscripts",
  "Amazing Charts",
  "AMS Software",
  "Antworks / Benchmark Solutions",
  "Aprima",
  "AYM Technologies",
  "Azalea Health",
  "Azcomp",
  "BestNotes",
  "Bizmatics / PrognoCIS",
  "Brightree",
  "CareCloud",
  "CarePaths",
  "Casehandler",
  "Centricity",
  "Cerbo",
  "Client Care Web",
  "CloudCraft",
  "CPSI / Evident",
  "Credible",
  "CureMD",
  "DAS Health",
  "Digital One",
  "DrChrono",
  "DSI",
  "e-MDs",
  "ECHO Group / Ensora Health",
  "Elation Health",
  "eMed Solutions / eNotes",
  "eRAD",
  "Experity",
  "Exscribe",
  "Flatiron Health",
  "Fuji Synapse",
  "Fusion Web Clinic",
  "GE Centricity",
  "GlaceEMR",
  "Greenway Intergy",
  "Greenway Prime Suite",
  "Healthie",
  "Healthland",
  "Homecare Homebase",
  "HST Pathways",
  "ICAN Solutions",
  "ICANotes",
  "ImagineSoftware",
  "Infian",
  "Infinite RIS",
  "Integrity / Checkpoint",
  "InterSystems",
  "Itelagen",
  "Jane",
  "Juno EHR",
  "Kalix",
  "Kareo / Tebra",
  "Kipu",
  "Kno2",
  "LeonardoMD",
  "Lightning Step",
  "Luminello",
  "MatrixCare",
  "Medent",
  "MEDHOST",
  "MedInformatix",
  "MediRecords",
  "Meditab / IMS",
  "MediTouch / HealthFusion",
  "MicroMD",
  "Modernizing Medicine / EMA",
  "Modernizing Medicine / gGastro",
  "MPN Software / Eclipse",
  "MyAvatar",
  "MyUnity",
  "Netsmart",
  "Nextech",
  "Nookal",
  "OCHIN",
  "Office Ally",
  "Office Practicum",
  "OmniMD",
  "One Partner",
  "Orchard Enterprise",
  "Patagonia Health",
  "PCC / Physician's Computer Company",
  "PioneerRx",
  "PointClickCare",
  "Practice Better",
  "Practice EHR",
  "Practice Fusion",
  "Practice Velocity / Experity / DocuTAP",
  "Praxis EMR",
  "PrognoCIS",
  "Psyche Systems",
  "Pulse",
  "Qualifacts",
  "Radysans",
  "Raintree Systems",
  "Relimed",
  "Remarkable Health",
  "RevolutionEHR",
  "RMPS",
  "RXNT",
  "SET-Works / Setworks",
  "Sevocity",
  "SimplePractice",
  "SmartCare",
  "SOAPware",
  "Speed Script",
  "Streamline Healthcare Solutions",
  "SuiteRx",
  "Suncoast",
  "Systems4PT",
  "T-System",
  "Tebra",
  "Therapy Appointment",
  "TherapyNotes",
  "TotalMD",
  "TriMed Complete",
  "TruBridge",
  "UHS Hospitals",
  "UltraLinq",
  "Uprise Health",
  "Valant",
  "Varian",
  "Veradigm",
  "VIP Pharmacy Systems",
  "VirtualHealth",
  "VistA",
  "Waiting Room Solutions / WRS",
  "WebPT",
  "Welligent",
  "WellSky",
  "Xperity",
  "Yosi Health",
  "zHealth",
];

/**
 * Builds the default list of EHR options with the Fixed Top 5 at the beginning,
 * followed by all other EHRs sorted alphabetically, and "Other" at the end.
 */
export function buildEhrOptions(extraOptions = []) {
  const fixedSet = new Set(FIXED_TOP_EHRS.map((e) => e.toLowerCase()));
  const extraList = Array.isArray(extraOptions) ? extraOptions : [];

  const restSet = new Set();
  const restList = [];

  [...ALL_EHRS, ...extraList].forEach((opt) => {
    const val = typeof opt === "string" ? opt.trim() : (opt?.value || opt?.label || "").trim();
    if (!val) return;
    const lower = val.toLowerCase();
    if (fixedSet.has(lower) || lower === "other") return;
    if (!restSet.has(lower)) {
      restSet.add(lower);
      restList.push(val);
    }
  });

  restList.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  return [...FIXED_TOP_EHRS, ...restList, "Other"];
}

export { filterAndSortList, filterAndSortList as filterAndSortEhrList };

